import React from "react";
import { Select } from "../../../lib";
// import ProgramsApi from "../../../services/resources/ProgramsApi";
import Toggle from "../../shared/Toggle";
import ManageParticipantsModal from "./ManageParticipantsModal";

export default class ProgramOverview extends React.PureComponent {
  state = {
    showManageParticipantsModal: false,
  };

  render() {
    const {
      actions,
      activeShluchim,
      program,
      programAudiences,
      programCategories,
      programOrig,
      restrictedEdit,
      schedule,
    } = this.props;

    return (
      <React.Fragment>
        <div className="program-form-inputs mb-8">
          <div className="flex flex-justify-space flex-align-center relative">
            <label className="form-label form-required" htmlFor="name">
              Program Name
            </label>
            <input
              type="text"
              id="name"
              value={program.name || ""}
              required
              autoComplete="off"
              autoFocus={true}
              data-change="program.name"
              onChange={actions.changeInput}
            />
          </div>
          <div className="flex flex-justify-space flex-align-center relative">
            <label className="form-label flex flex-align-center" htmlFor="url">
              Public About Page (URL)
              <span className="tooltip-container">
                <i className="material-icons large-text ml-8 accent-text-dark">
                  info
                </i>
                <span className="tooltip tooltip-medium-width">
                  Link for external public pages that’s related to this program.
                  This link will always display in this program card in the
                  Shluchim Portal (Ex, URL of public site for Pegisha info,
                  etc.). For Grand Draw, this will also be used as the base URL
                  for the auto-generated iframe codes for shluchim.
                </span>
              </span>
            </label>
            <input
              type="text"
              id="url"
              value={program.url || ""}
              autoComplete="off"
              data-change="program.url"
              onChange={actions.changeInput}
            />
          </div>
        </div>
        <div className="program-form-inputs mb-8">
          <div className="flex flex-justify-space flex-align-center relative">
            <label className="form-label form-required" htmlFor="audience">
              Program Audience
            </label>
            <Select
              id="audience"
              options={programAudiences.map((i) => ({
                value: i.intValue,
                label: i.displayValue,
              }))}
              value={program.audienceId || -1}
              clearable={false}
              data-change="program.audienceId"
              onChange={actions.changeInput}
              required={true}
            />
          </div>
          <div className="flex flex-justify-space flex-align-center relative">
            <label className="form-label form-required" htmlFor="category">
              Program Category
            </label>
            <Select
              id="category"
              options={programCategories.map((i) => ({
                value: i.intValue,
                label: i.displayValue,
              }))}
              value={program.categoryId || -1}
              clearable={true}
              data-change="program.categoryId"
              onChange={actions.changeInput}
              required={true}
            />
          </div>
        </div>
        <div className="program-form-inputs mb-8">
          <div
            className="flex flex-justify-space relative"
            style={{ alignItems: "flex-start", gridColumnStart: "span 2" }}
          >
            <label
              className="form-label flex flex-align-center mt-8"
              htmlFor="description"
            >
              Program Description
            </label>
            <textarea
              id="description"
              rows="4"
              value={program.description || ""}
              data-change="program.description"
              onChange={actions.changeInput}
              required={true}
            />
          </div>
        </div>
        <div className="program-form-toggle program-form-inputs mb-16">
          <div
            className="flex flex-align-center relative"
            style={{ gridColumnStart: "span 2" }}
          >
            <label
              className="form-label flex flex-align-center"
              htmlFor="includesAllShluchim"
            >
              Program Restrictions
            </label>
            <Toggle
              disabled={restrictedEdit}
              id="includesAllShluchim"
              name="program.includesAllShluchim"
              onChange={() =>
                actions.changeState(
                  "program.includesAllShluchim",
                  !program.includesAllShluchim,
                )
              }
              options={[
                {
                  value: true,
                  display: "None",
                },
                {
                  value: false,
                  display: "Entire Program Restricted",
                },
              ]}
              value={program.includesAllShluchim}
              data-change="program.includesAllShluchim"
            />
            {!program.includesAllShluchim && (
              <div className="tooltip-container">
                <p
                  className={`${
                    program.id ? "link-text" : "accent-text"
                  } uppercase-text ml-32 fw-700`}
                  onClick={() =>
                    program.id
                      ? this.setState({ showManageParticipantsModal: true })
                      : {}
                  }
                  style={program.id ? {} : { cursor: "not-allowed" }}
                >
                  Manage Participants
                </p>
                {!program.id && (
                  <span
                    className="tooltip line-height-double"
                    // style={{ whiteSpace: "normal", width: "320px" }}
                  >
                    You can manage program particpants after the program is
                    created.
                  </span>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="program-form-toggle program-form-inputs mb-16">
          <div
            className="flex flex-align-center relative"
            style={{ gridColumnStart: "span 2" }}
          >
            <label
              className="form-label flex flex-align-center"
              htmlFor="registrationType"
            >
              Registration Type
            </label>
            <Toggle
              allowNoOption={true}
              disabled={restrictedEdit}
              id="registrationType"
              name="program.registrationType"
              onChange={(_, val) => {
                actions.changeState("program.registrationType", val);
                if (val !== "Shliach" && !!schedule.registrationMethod) {
                  actions.changeState(
                    "schedule.registrationMethod",
                    "Standard",
                  );
                }
                if (
                  programOrig.registrationType &&
                  programOrig.registrationType !== val
                ) {
                  window.alert(
                    "Note that if there are existing registrations for this program, changing the Registration Type is not allowed and changes will not be able to be saved",
                  );
                }
              }}
              options={[
                {
                  value: "Shliach",
                  display: "Shluchim",
                },
                {
                  value: "Student",
                  display: "Students",
                },
              ]}
              value={program.registrationType}
              data-change="program.registrationType"
            />
          </div>
        </div>
        <div className="program-form-toggle program-form-inputs mb-16">
          <div
            className="flex flex-align-center relative"
            style={{ gridColumnStart: "span 2" }}
          >
            <label
              className="form-label flex flex-align-center"
              htmlFor="allowMultipleRegistrations"
            >
              Allow Repeat Registrations
            </label>
            <Toggle
              disabled={restrictedEdit}
              id="allowMultipleRegistrations"
              name="program.allowMultipleRegistrations"
              onChange={() =>
                actions.changeState(
                  "program.allowMultipleRegistrations",
                  !program.allowMultipleRegistrations,
                )
              }
              options={[
                {
                  value: false,
                  display: "No",
                },
                {
                  value: true,
                  display: "Yes",
                },
              ]}
              value={!!program.allowMultipleRegistrations}
              data-change="program.allowMultipleRegistrations"
            />
          </div>
        </div>
        <div className="program-form-toggle program-form-inputs mb-16">
          <div
            className="flex flex-align-center relative"
            style={{ gridColumnStart: "span 2" }}
          >
            <label
              className="form-label flex flex-align-center"
              htmlFor="hasApplicationProcess"
            >
              Application Process
            </label>
            <Toggle
              disabled={restrictedEdit}
              id="hasApplicationProcess"
              name="program.hasApplicationProcess"
              onChange={() => {
                actions.changeState(
                  "program.hasApplicationProcess",
                  !program.hasApplicationProcess,
                );
                if (
                  programOrig.hasApplicationProcess &&
                  program.hasApplicationProcess
                ) {
                  window.alert(
                    "Turning off the Application Process setting will cause access to application data for existing schedule registrations to be lost",
                  );
                }
              }}
              options={[
                {
                  value: false,
                  display: "None",
                },
                {
                  value: true,
                  display: "Application Process",
                },
              ]}
              value={!!program.hasApplicationProcess}
              data-change="program.hasApplicationProcess"
            />
          </div>
        </div>
        <div className="program-form-inputs mb-8">
          <div className="flex flex-justify-space flex-align-center relative">
            <label
              className="form-label flex flex-align-center"
              htmlFor="resourcesFolderID"
            >
              Resource Folder ID
              <span className="tooltip-container">
                <i className="material-icons large-text ml-8 accent-text-dark">
                  info
                </i>
                <span className="tooltip tooltip-medium-width">
                  Enter the ID from the URL of the google drive resources folder
                  for this program.
                </span>
              </span>
            </label>
            <input
              type="text"
              id="resourcesFolderID"
              value={program.resourcesFolderID || ""}
              autoComplete="off"
              data-change="program.resourcesFolderID"
              onChange={actions.changeInput}
            />
          </div>
        </div>
        {program.id && (
          <ManageParticipantsModal
            show={this.state.showManageParticipantsModal}
            programId={program.id}
            shluchim={activeShluchim}
            onClose={() =>
              this.setState({ showManageParticipantsModal: false })
            }
            route={this.props.route}
            router={this.props.router}
          />
        )}
      </React.Fragment>
    );
  }
}
